<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <!--          <li>-->
          <!--            <router-link :to="{ name: 'PrivacyPolicy' }">-->
          <!--              {{ $t("landing_page.privacy_policy") }}-->
          <!--            </router-link>-->
          <!--          </li>-->
          <!--          <li>-->
          <!--            <router-link :to="{ name: 'TermsOfUse' }">-->
          <!--              {{ $t("landing_page.terms_of_use") }}-->
          <!--            </router-link>-->
          <!--          </li>-->
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <router-link :to="{ name: 'UniversityList' }">{{
          $t("common.project_full_name")
        }}</router-link>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
